import {ThunkResult, UserProfileData} from "../../types";
import {
    createArchetype,
    createCallback,
    deleteArchetype,
    deleteCallback,
    getArchetypes,
    getCallbacks,
    getUserCredits,
    loggedUser,
    resendEmail,
    resetPassword,
    updateUserProfile
} from "../../api/users";
import {createdApiKeys, gotApiKeys, gotArchetypes, gotCallbacks, gotUserCredits, setCreating, setLoading, setUser} from "../users";
import {createApiKey, deleteApiKeys, getApiKeys} from "../../api/apikeys";
import {GetParams, noop} from "@kopjra/uikit";
import {ArchetypeCreation, Callback} from "../../types/users";
import {showAlert, transformToArchetypeParams, transformToCallbackParams} from "../../utils/commons";
import {FetchError} from "../../api";
import {I18n} from "react-redux-i18n";

export const doLoggedUser = (): ThunkResult<Promise<void>> => async (dispatch) => {
    dispatch(setLoading(true));
    try {
        const user = await loggedUser();
        dispatch(setUser(user));
    } catch (e) {
        // noop;
    } finally {
        dispatch(setLoading(false));
    }
}

export const doResendEmail = (): ThunkResult<Promise<void>> => async () => {
    await resendEmail();
}

export const doResetPassword = (): ThunkResult<Promise<void>> => async () => {
    await resetPassword();
}

export const doUpdateUserProfile = (up: UserProfileData): ThunkResult<Promise<void>> => async () => {
    await updateUserProfile(up);
}

export const doGetApiKeys = (ignoreAuthResponse?: boolean): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
        dispatch(gotApiKeys(await getApiKeys(ignoreAuthResponse)));
    } catch {
        noop();
    }
}

export const doDeleteApiKey = (id: string): ThunkResult<Promise<void>> => async () => {
    await deleteApiKeys(id);
}

export const doCreateApiKey = (): ThunkResult<Promise<void>> => async (dispatch) => {
    dispatch(setCreating(true));
    try {
        await dispatch(createdApiKeys(await createApiKey()));
        dispatch(doGetApiKeys()).catch();
    } finally {
        dispatch(setCreating(false));
    }
}

export const doGetUserCredits = (): ThunkResult<Promise<void>> => async (dispatch) => {
    dispatch(gotUserCredits(await getUserCredits()));
}

export const doGetCallbacks = (query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    dispatch(gotCallbacks(await getCallbacks(transformToCallbackParams(query))));
}

export const doCreateCallback = (body: Callback, query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    await createCallback(body);
    await dispatch(doGetCallbacks(query));
}

export const doDeleteCallback = (id: string, query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    await deleteCallback(id);
    await dispatch(doGetCallbacks(query));
}

export const doGetArchetypes = (query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    dispatch(gotArchetypes(await getArchetypes(transformToArchetypeParams(query))));
}

export const doCreateArchetype = (body: ArchetypeCreation, query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    await createArchetype(body);
    await dispatch(doGetArchetypes(query));
}

export const doDeleteArchetype = (id: string, query: GetParams): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
        await deleteArchetype(id);
    } catch (error) {
        if (error instanceof FetchError && error.response.status === 423) {
            showAlert(I18n.t("archetypes.errorDeleting"));
        } else {
            showAlert(I18n.t("error.delete"));
        }
    }
    await dispatch(doGetArchetypes(query));
}
